// This file was automatically generated from app.settings.templates.html.
// Please don't edit this file by hand.

goog.provide('el8.template.app.settings.templates');

goog.require('soy');
goog.require('soy.StringBuilder');
goog.require('el8.template.app.data.checklistTemplates');
goog.require('el8.template.uiwidget.Icd10ListEditor');
goog.require('el8.template.util.validate');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.app.settings.templates.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<h1 id="template-settings-page-top" class="el8PageTitle">Templates</h1><div class="el8SettingsJumpTo"><p>Jump to: <a href="#ros-template-settings">ROS Templates</a> | <a href="#letter-template-settings">Letter &amp; Referral Templates</a> ', (! el8Globals.FEATURES.BiDiLabs) ? '| <a href="#order-set-template-settings">Lab Order Sets</a>' : '', ' </p></div><h3 id="pe-template-settings" class="el8Bold mv10">PE Templates</h3><div class="pe-template-section"><ol class="pe-template-list el8Loading ebs-list-unstyled"></ol><button class="add-trigger ebs-btn ebs-btn-default">+ Add PE Template</button></div><div class="mt30"><p><a class="ebs-pull-right" href="#template-settings-page-top">(Return to Top)</a></p><h3 id="ros-template-settings" class="el8Bold mb10">ROS Templates</h3><div class="ros-template-section"><ol class="ros-template-list el8Loading ebs-list-unstyled"></ol><button class="add-trigger ebs-btn ebs-btn-default">+ Add ROS Template</button></div></div><div class="mt30"><p><a class="ebs-pull-right" href="#template-settings-page-top">(Return to Top)</a></p><h3 id="letter-template-settings" class="el8Bold mb10">Letter &amp; Referral Templates</h3><div class="letter-template-section"><ol class="letter-template-list el8Loading ebs-list-unstyled"></ol><button class="add-trigger ebs-btn ebs-btn-default">+ Add Letter Template</button></div></div>', (! el8Globals.FEATURES.BiDiLabs) ? '<div class="mt30"><p><a class="ebs-pull-right" href="#template-settings-page-top">(Return to Top)</a></p><h3 id="order-set-template-settings" class="el8Bold mb10">Lab Order Sets</h3><div id="lab-order-set-by-vendors"></div></div>' : '');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.app.settings.templates.labOrderSetByFacilities = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  var facilityList7522 = opt_data.facilities;
  var facilityListLen7522 = facilityList7522.length;
  for (var facilityIndex7522 = 0; facilityIndex7522 < facilityListLen7522; facilityIndex7522++) {
    var facilityData7522 = facilityList7522[facilityIndex7522];
    output.append('<div facility-id="', soy.$$escapeHtml(facilityData7522.facilityId), '" ', (! (facilityIndex7522 == 0)) ? 'class="mt20"' : '', '>');
    el8.template.app.settings.templates.labOrderSetByFacility(facilityData7522, output);
    output.append('</div>');
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.app.settings.templates.labOrderSetByFacility = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((opt_data.displayName) ? '<h4>' + soy.$$escapeHtml(opt_data.displayName) + '</h4>' : '', '<div class="lab-order-set-section" ><ol class="lab-order-set-list el8Loading ebs-list-unstyled"></ol><button class="add-trigger ebs-btn ebs-btn-default">+ Add Lab Order Set</button></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.app.settings.templates.checklistList = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  var templateList7541 = opt_data.checklistTemplates;
  var templateListLen7541 = templateList7541.length;
  for (var templateIndex7541 = 0; templateIndex7541 < templateListLen7541; templateIndex7541++) {
    var templateData7541 = templateList7541[templateIndex7541];
    output.append('<li class="curated-list-item el8SettingsSortListItem" data-id="', soy.$$escapeHtml(templateData7541.id), '"><div class="expand-collapse-trigger el8Clickable"><span class="collapsible-status el8Elt"></span><a class="expand-trigger el8StandardFontSize padl3">', soy.$$escapeHtml(templateData7541.name), ' </a><p class="el8MedGray el8FontSmall el8Ellipsis padt3 padl20 template-description-snippet">');
    el8.template.app.data.checklistTemplates.templateSingleLine({template: templateData7541}, output);
    output.append('</p></div><div class="collapsible-section padt10 ebs-form-horizontal">');
    var fieldList7550 = templateData7541.fields;
    var fieldListLen7550 = fieldList7550.length;
    for (var fieldIndex7550 = 0; fieldIndex7550 < fieldListLen7550; fieldIndex7550++) {
      var fieldData7550 = fieldList7550[fieldIndex7550];
      output.append('<div class="el8FieldSection ebs-form-group"><label class="ebs-control-label ebs-col-sm-2">', soy.$$escapeHtml(fieldData7550.name), ':</label><p class="ebs-col-sm-10 mb5">', soy.$$escapeHtml(fieldData7550.value), '</p></div>');
    }
    output.append('<div class="padv5"><a class="edit-trigger el8Link">edit</a><a class="remove-trigger el8Link ml10">remove</a></div></div></li>');
  }
  output.append('<li class="new-form-stub"></li>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.app.settings.templates.checklistForm = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<form class="el8SettingsInlineForm ebs-form-horizontal"><div><div class="el8SettingsInlineFormField field-wrapper mb10"><label>Name:</label><div class="el8FieldSection el8EditorTextareaWrap mt2"><input name="name" class="ebs-form-control" /></div>');
  el8.template.util.validate.errorMsg({msg: 'Please enter a template name.'}, output);
  output.append('</div>');
  var choiceList7565 = opt_data.choices;
  var choiceListLen7565 = choiceList7565.length;
  for (var choiceIndex7565 = 0; choiceIndex7565 < choiceListLen7565; choiceIndex7565++) {
    var choiceData7565 = choiceList7565[choiceIndex7565];
    output.append('<div class="el8SettingsInlineFormField ebs-row"><label class="el8SettingsInlineFormLabel ebs-control-label ebs-col-sm-2 padr0">', soy.$$escapeHtml(choiceData7565), '</label><div class="el8FieldSection ebs-col-sm-10"><textarea name="', soy.$$escapeHtml(choiceData7565), '" class="el8EditorTextareaWrap ebs-form-control padv0"></textarea></div></div>');
  }
  output.append('<div class="el8InlineBlock form-buttons"></div></div></form>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.app.settings.templates.labOrderSetList = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  var templateList7574 = opt_data.labOrderSets;
  var templateListLen7574 = templateList7574.length;
  for (var templateIndex7574 = 0; templateIndex7574 < templateListLen7574; templateIndex7574++) {
    var templateData7574 = templateList7574[templateIndex7574];
    output.append('<li class="curated-list-item el8SettingsSortListItem" data-id="', soy.$$escapeHtml(templateData7574.id), '"><div class="expand-collapse-trigger el8Clickable"><span class="collapsible-status el8Elt"></span><a class="el8StandardFontSize padl3', (templateData7574.icd9Codes.length && ! templateData7574.icd10Codes.length) ? ' el8ProblemNeedsXWalkHighlight' : '', '">', soy.$$escapeHtml(templateData7574.name), '</a><p class="el8MedGray el8FontSmall el8Ellipsis template-description-snippet padt3 padl20">');
    var testObjList7584 = templateData7574.tests;
    var testObjListLen7584 = testObjList7584.length;
    for (var testObjIndex7584 = 0; testObjIndex7584 < testObjListLen7584; testObjIndex7584++) {
      var testObjData7584 = testObjList7584[testObjIndex7584];
      output.append('<span class="', (testObjData7584.mixed) ? 'el8AttentionText el8Bold' : '', '">', soy.$$escapeHtml(testObjData7584.name), '</span>', (! (testObjIndex7584 == testObjListLen7584 - 1)) ? ', ' : '');
    }
    output.append('</p></div><div class="collapsible-section ebs-form-horizontal"><div class="padv10 ebs-row"><div class="cardColumn ebs-col-sm-6 ebs-col-sm-push-6">');
    if (templateData7574.icd10Codes.length || templateData7574.icd9Codes.length) {
      output.append('<div class="el8FieldSection ebs-form-group"><label class="ebs-control-label ebs-col-sm-2">ICD-10:</label><div class="ebs-col-sm-10"><ol class="ebs-list-unstyled">');
      var cList7600 = templateData7574.icd10Codes;
      var cListLen7600 = cList7600.length;
      if (cListLen7600 > 0) {
        for (var cIndex7600 = 0; cIndex7600 < cListLen7600; cIndex7600++) {
          var cData7600 = cList7600[cIndex7600];
          output.append('<li class="el8BulletText">', soy.$$escapeHtml(cData7600), '</li>');
        }
      } else {
        output.append('<li class="el8BulletText el8Bold">Requires Crosswalk</li>');
      }
      output.append('</ol></div></div>');
    }
    if (templateData7574.icd9Codes.length) {
      output.append('<div class="el8FieldSection ebs-form-group"><label class="ebs-control-label ebs-col-sm-2">ICD-9:</label><div class="ebs-col-sm-10"><ol class="ebs-list-unstyled">');
      var cList7611 = templateData7574.icd9Codes;
      var cListLen7611 = cList7611.length;
      for (var cIndex7611 = 0; cIndex7611 < cListLen7611; cIndex7611++) {
        var cData7611 = cList7611[cIndex7611];
        output.append('<li class="el8BulletText">', soy.$$escapeHtml(cData7611), '</li>');
      }
      output.append('</ol></div></div>');
    }
    output.append('</div>');
    if (templateData7574.tests) {
      output.append('<div class="cardColumn ebs-col-sm-6 ebs-col-sm-pull-6"><div class="el8FieldSection ebs-form-group"><label class="ebs-control-label ebs-col-sm-2">Tests:</label><div class="ebs-col-sm-10"><ol class="ebs-list-unstyled">');
      var testObjList7621 = templateData7574.tests;
      var testObjListLen7621 = testObjList7621.length;
      for (var testObjIndex7621 = 0; testObjIndex7621 < testObjListLen7621; testObjIndex7621++) {
        var testObjData7621 = testObjList7621[testObjIndex7621];
        output.append('<li class="el8BulletText">', soy.$$escapeHtml(testObjData7621.name), '</li>');
      }
      output.append('</ol></div></div></div>');
    }
    output.append('</div><div class="padv5"><a class="edit-trigger el8Link">edit</a><a class="remove-trigger el8Link ml10">remove</a></div></div></li>');
  }
  output.append('<li class="new-form-stub"></li>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.app.settings.templates.labOrderSetForm = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<form class="el8SettingsInlineForm"><div class="el8MessageContainer el8OrangeDashedBox el8Hidden needs-xwalk-container ebs-alert ebs-alert-warning"></div><div class=""><div class="el8SettingsInlineFormField field-wrapper"><label>Name:</label><div class="el8FieldSection el8EditorTextareaWrap"><input name="name" class="ebs-form-control" /></div>');
  el8.template.util.validate.errorMsg({msg: 'Please enter a template name.'}, output);
  output.append('</div><div class="ebs-form-horizontal ebs-container-fluid padt10"><div class="fieldNoteSection"><div class="ebs-form-group"><label class="el8SettingsAddressLabel ebs-control-label ebs-col-sm-2">Tests:</label><div class="ebs-col-sm-10"><ol class="order-set-tests-list ebs-list-unstyled"></ol><input type="text" class="ebs-form-control" name="tests" /></div></div></div><div class="fieldNoteSection"><div class="ebs-form-group"><label class="el8SettingsAddressLabel ebs-control-label ebs-col-sm-2">Dx:</label><div class="ebs-col-sm-10 padr10">');
  el8.template.uiwidget.Icd10ListEditor.billDxEntryField({index: null}, output);
  output.append('</div></div></div></div><div class="el8InlineBlock form-buttons"></div></div></form>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.app.settings.templates.letterTemplateList = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  var templateList7639 = opt_data.letterTemplates;
  var templateListLen7639 = templateList7639.length;
  for (var templateIndex7639 = 0; templateIndex7639 < templateListLen7639; templateIndex7639++) {
    var templateData7639 = templateList7639[templateIndex7639];
    output.append('<li class="curated-list-item el8SettingsSortListItem" data-id="', soy.$$escapeHtml(templateData7639.id), '"><div class="expand-collapse-trigger el8Clickable"><span class="collapsible-status el8Elt"></span><a class="el8StandardFontSize padl3">', soy.$$escapeHtml(templateData7639.name), '</a><p class="el8MedGray el8FontSmall el8Ellipsis template-description-snippet padl20 padt3">', soy.$$escapeHtml(templateData7639.body), '</p></div><div class="collapsible-section ebs-form-horizontal">', (templateData7639.subject) ? '<div class="el8FieldSection ebs-form-group"><label class="ebs-control-label ebs-col-sm-2">Subject:</label><div class="ebs-col-sm-10">' + soy.$$escapeHtml(templateData7639.subject) + '</div></div>' : '', '<div class="el8FieldSection ebs-form-group"><label class="ebs-control-label ebs-col-sm-2">Body:</label><div class="ebs-col-sm-10">', soy.$$escapeHtml(templateData7639.body), '</div></div><div class="padv5"><a class="edit-trigger el8Link">edit</a><a class="remove-trigger el8Link ml10">remove</a></div></div></li>');
  }
  output.append('<li class="new-form-stub"></li>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.app.settings.templates.letterTemplateForm = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<form class="el8SettingsInlineForm"><div class=""><div class="el8SettingsInlineFormField field-wrapper"><label>Name:</label><div class="el8FieldSection el8EditorTextareaWrap"><input name="name" class="ebs-form-control" /></div>');
  el8.template.util.validate.errorMsg({msg: 'Please enter a template name.'}, output);
  output.append('</div><div class="el8SettingsInlineFormField"><label>Subject:</label><div class="el8FieldSection el8EditorTextareaWrap"><input name="subject" class="ebs-form-control" /></div></div><div class="el8SettingsInlineFormField"><label>Body:</label><div class="el8FieldSection el8EditorTextareaWrap"><textarea name="body" class="ebs-form-control"></textarea></div></div><div class="el8InlineBlock form-buttons"></div></div></form>');
  if (!opt_sb) return output.toString();
};
